import { reactive, UnwrapNestedRefs } from "vue";
import { Store } from "../src/Store";
import { ConstructionWorkApi } from "../src/Api/ConstructionWorkApi";

export const store: UnwrapNestedRefs<Store> = reactive<Store>(new Store(ConstructionWorkApi))
